module.exports = __webpack_public_path__ + "static/media/purchase.3c45dcae.svg";